import * as actions from "./invoice.actions";
import * as api from "./invoice.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./invoice.constants";
import * as hooks from "./invoice.hooks";
import * as promises from "./invoice.promises";
import reducer from "./invoice.reducer";
import { saga } from "./invoice.saga";
import * as selectors from "./invoice.selectors";
import * as utils from "./invoice.utils";
export * from "./invoice.types";
export var REDUCER_KEY_INVOICE = REDUCER_KEY;
export var invoiceModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
